<template>
  <div>
    <van-nav-bar title="资讯详情" fixed="fixed">
      <template #left>
        <div @click="$back(this)" @dblclick="$backHome(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
      <template #right>
        <div style="margin-right: 20px" @click="collection">
          <svg-icon :icon-class="isCollection?'isCollection':'detailCollection'"
                    style="width:20px;height:20px;"></svg-icon>
        </div>
        <div @click="$store.state.shareShow=true">
          <svg-icon icon-class="detailShare" style="width:20px;height:18px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <share></share>

    <div style="padding-top: 46px;">
      <transition name="fade" appear>
        <lazy-component>
          <div class="background" v-if="infoDRes.data">
            <div class="mainBody">
              <div class="inBody">

                <div class="title">
      <span>
        {{ infoDRes.data.title }}
      </span>
                </div>
                <div class="articleInfo">

                  <div class="date">{{ infoDRes.data.release_time_check }}</div>
                  <div class="authorD">{{ infoDRes.data.author_CN }}</div>

                  <div class="informationTypeCN">{{ infoDRes.data.information_type_CN }}</div>

                  <div class="tradingDirection"
                       :style="'backgroundColor:'+(infoDRes.data.directionId === 1?'#f84242':infoDRes.data.trading_direction_id === 2?'#2eba94':'#a8a8a8')">
                    {{ infoDRes.data.trading_direction_id_CN }}
                  </div>
                </div>

                <div v-if="infoDRes.data.symbol" @click="$goChart(infoDRes.data.symbol)">
                  <div class="marketShow"
                       :style="'backgroundColor:'+(infoDRes.data.symbol && parseFloat(priceData[infoDRes.data.symbol].rateProfit) <0?'#edfef8':'#fff1f2')">
                    <div class="marketShowLine"
                         :style="'backgroundColor:'+(infoDRes.data.symbol && parseFloat(priceData[infoDRes.data.symbol].rateProfit) <0?'#2eba94':'#f84242')"></div>

                    <div class="symbolNameD">{{ infoDRes.data.symbol_cn }}({{ infoDRes.data.symbol }})</div>


                    <div class="symbolArrow">
                      <svg-icon icon-class="detailArrow" style="width:5px;height:9px;"></svg-icon>
                    </div>
                    <div class="symbolRP">{{ priceData[infoDRes.data.symbol].rateProfit }}%</div>
                    <div class="symbolS">{{ priceData[infoDRes.data.symbol].strike }}</div>
                  </div>
                </div>

                <div class="descriptionBox">
                  <img :src="infoDRes.data.cover" class="cover">
                </div>
                <div class="textCon" v-html="infoDRes.data.content">
                </div>
                <div class="authorInfo" v-if="infoDRes.data.author_CN">
                  <img :src="infoDRes.data.author_head_portrait" class="authorHeadPortrait">
                  <div class="auInfoRight">
                    <div class="above">
                      <div class="authorName">{{ infoDRes.data.author_CN }}</div>
                      <div class="articleNum">{{ infoDRes.data.author_article_num }}篇文章</div>
                    </div>
                    <div class="below">
                      <div class="description">{{ infoDRes.data.author_description }}</div>
                    </div>
                  </div>
                </div>
                <div class="remind">
          <span>
          【风险提示】市场有风险，投资需谨慎。<br/>
          【免责声明】图表家的文章和策略资讯以及所表达意见仅作参考之用,不构成任何投资、法律、会计或税务的最终操作建议，图表家（上海向右网络科技有限公司）不就资讯中的内容对最终操作建议做出任何担保，投资者根据资讯作出的任何投资决策与图表家（上海向右网络科技有限公司）及资讯作者无关。
      </span>
                </div>


                <div class="dLine"></div>

                <div class="ad" v-for="(item,index) in adRes.data">
                  <img :src="item.images" style="width: 100%;height: auto" @click="goAd(index)">
                </div>
                <div style="height: 20px"></div>
              </div>
            </div>
            <div class="recommend">
              <div class="reTitleBox van-hairline--bottom"><span class="reTitle">相关推荐</span></div>


              <div v-for="(itemRe,indexRe) in recommendRes.data.list" class="reBoxOut" :key="indexRe"
                   v-if="recommendRes.data.list.length>0">
                <router-link :to="{ path: '/informationDetail', query: { id: itemRe.id} }">
                  <div class="reBox" @click="backTop">
                    <div class="reImgBox">
                      <img :src="itemRe.cover" class="reImg">
                    </div>

                    <div class="reRightBox">
                      <div class="reSonTitle">
                        {{ itemRe.title }}
                      </div>
                      <div class="reDate">{{ $stDateChange(itemRe.release_time_check) }}</div>


                    </div>
                  </div>
                </router-link>
                <div class="reDLine"></div>
              </div>


            </div>
          </div>
        </lazy-component>
      </transition>
    </div>
  </div>
</template>

<script>

import Share from "@/components/public/share";

export default {
  name: "informationDetail",
  components: {Share},
  data() {
    return {
      query: {},
      isCollection: false,
      infoQuery: {},
      infoDRes: {data: {}},
      adRes: {data: {}},
      recommendRes: {data: {}},
      priceData: {},

    }
  },
  methods: {
    collection() {
      if (this.$store.state.SignedIn) {
        this.query.member_uuid = localStorage.getItem('member_uuid')
        this.query.api_token = localStorage.getItem('api_token')
        this.query.information_type = 2
        this.query.information_id = parseInt(this.$route.query.id)
        let query = this.$encrypt(this.$genQuery(this.query))
        if (this.isCollection) {
          this.$get(this.$store.state.apiUrl + '/information/cancelCollection', {qdata: query}).then(res => {

            if (res.status === 0) {
              this.$toast(res.msg);
              this.isCollection = false
            } else {
              this.$toast(res.msg);
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$get(this.$store.state.apiUrl + '/information/addCollection', {qdata: query}).then(res => {

            if (res.status === 0) {
              this.$toast(res.msg);
              this.isCollection = true
            } else {
              this.$toast(res.msg);
            }
          }).catch(err => {
            console.log(err)
          })
        }
      } else {
        this.$store.state.searchLock = true;
        this.$store.state.searchShow = false;
        this.$store.state.menuOpen = true;

        this.$toast('请先登录');
        this.$router.push('/login');
      }
    },
    checkCollection() {
      if (this.$store.state.SignedIn) {
        this.query.member_uuid = localStorage.getItem('member_uuid')
        this.query.api_token = localStorage.getItem('api_token')
        this.query.information_type = 2
        this.query.page_size = 100
        let query = this.$encrypt(this.$genQuery(this.query))
        this.$get(this.$store.state.apiUrl + '/information/Collection', {qdata: query}).then(res => {

          if (res.data.list) {
            if (res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                if (parseInt(this.$route.query.id) === res.data.list[i].id) {
                  this.isCollection = true
                  break
                } else {
                  this.isCollection = false
                }
              }
            } else {
              this.isCollection = false
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    getAd() {

      let query = this.$encrypt(this.$genQuery({evkey: 'app_article_info'}))
      this.$post(this.$store.state.apiUrl + "/ads/getad", {qdata: query}).then(res => {
        // this.axios.post('/ads/getad?qdata=' + this.adInfo).then(res => {
        this.$forceUpdate();
        this.adRes = res

      }).catch(err => {
        console.log(err)
      })
    },


    Load(query) {
      if (query.id === undefined) {
        this.$router.push("/")
      } else {
        query = this.$encrypt(this.$genQuery(query))
        this.$get(this.$store.state.apiUrl + "/information/articleInfo", {qdata: query}).then(res => {
          this.infoDRes = res
          if (this.infoDRes.data.symbol) {
            this.connectWs([this.infoDRes.data.symbol])
          } else {
            this.connectWs([])
          }
          window.scrollTo(0, 0)
        }).catch(err => {
        })
      }
    },

    loadRecommend(id) {
      id = this.$encrypt(this.$genQuery(id))
      this.$get(this.$store.state.apiUrl + "/information/articleRecommend", {qdata: id}).then(res => {
        this.recommendRes = res

      }).catch(err => {
        console.log(err)
      })

    },


    getFreshPrice: function () {
      if (localStorage.newPriceKey) {
        this.priceData = JSON.parse(localStorage.newPriceKey)
        this.$forceUpdate()
      }
    },
    goAd(index) {
      let urlSplit = this.adRes.data[index].jumpinfo.split("=")
      let title = this.adRes.data[index].title
      let url = urlSplit[1]
      if (url) {
        this.$router.push({path: '/advertisement', query: {url, title}})
      }
    },
    backTop() {
      window.scrollTo(0, 0)
    }
  },
  created() {
    this.checkCollection()
  },
  mounted() {
    this.Load({id: this.$route.query.id, is_edit: this.$route.query.preview || ''})
    this.getAd()
    this.loadRecommend({id: this.$route.query.id})
    this.getFreshPrice()
    window.addEventListener('newPrice', this.getFreshPrice)
  },
  watch: {
    $route() {
      this.Load({id: this.$route.query.id, is_edit: this.$route.query.preview || ''})
      this.getAd()
      this.loadRecommend({id: this.$route.query.id})
      this.getFreshPrice()
      this.checkCollection()
    }
  },
}
</script>

<style lang="scss" scoped>


/*page*/
.background {
  background-color: #f4f6fa;
}

.mainBody {
  width: 100%;
  background-color: white;
}

.inBody {
  padding: 0 16px;
}

.title {
  font-size: 20px;
  text-align: left;
  padding: 20px 0;
  font-weight: bolder;
}

.articleInfo {
  height: 16px;
  padding: 3px 0;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.date {
  font-size: 12px;
  float: left;
  color: #919bad;
}

.authorD {
  font-size: 12px;
  margin: 0 7px;
  float: left;
}

.informationTypeCN {
  font-size: 12px;
  margin-left: auto;
  margin-right: 12px;
}

.tradingDirection {
  font-size: 12px;
  border-radius: 3px;
  color: white;
  padding: 0 3px;
}

.marketShow {
  height: 36px;
  font-size: 14px;
  font-weight: bolder;
}

.marketShowLine {
  height: 2px;
  margin-bottom: 6px;
}

.symbolNameD {
  margin-left: 16px;
  margin-top: 2px;
  float: left;

}

.symbolRP {
  margin-right: 15px;
  margin-top: 2px;
  float: right;
}

.symbolS {
  margin-right: 15px;
  margin-top: 2px;
  float: right;
}

.symbolArrow {
  float: right;
  margin-right: 16px;
}

.descriptionBox {
  margin-top: 13px;
}

.cover {
  width: 100%;
  border: 1px solid;
  color: #e6e6e6;
  box-sizing: border-box;
}

.textCon {
  width: 100%;
  font-size: 15px;
  /*font-family: "PingFang SC";*/
  /deep/ * {
    text-align: left;
    line-height: 25px;
    font-size: 15px !important;
    font-style: normal !important;

    img {
      height: auto !important;
      max-width: 100% !important;
      margin: 15px 0 !important;
    }
  }
}

.authorInfo {
  width: 100%;
  height: auto;
  background-color: #ecf0f6;
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.authorHeadPortrait {
  width: 36px;
  height: 36px;
  position: relative;
  margin: 15px 15px;
  float: left;
  border-radius: 25px;
}

.above {
  height: auto;
  min-height: 33px;
  display: flex;
  align-items: baseline;
}

.authorName {
  font-weight: bolder;
}

.articleNum {
  padding-top: 14px;
  margin: 0 16px;
  font-size: 12px;
  color: #919bad;
}

.below {
  height: auto;
  min-height: 33px;
  text-align: left;
  padding: 0 15px 10px 0;
}

.description {
  font-size: 12px;
  float: left;
  color: #919bad;
}

.remind {
  text-align: left;
  font-size: 13px;
  color: #919bad;
  margin: 10px 0;
}

.dLine {
  width: 100%;
  height: 1px;
  background-color: #edf0f4;
  margin: 20px 0;
}

.ad {
  width: 100%;
  height: auto;
}

.recommend {
  width: 100%;
  margin-top: 3px;
  background-color: white;
}

.reTitleBox {
  height: 35px;
  width: 100%;
  display: flex;
  align-items: center;
}

.reTitle {
  font-weight: bolder;
  margin-left: 16px;
  font-size: 14px;
}


.reBoxOut {

}

.reBox {
  height: 96px;
  width: 100%;
  display: flex;
}

.reImgBox {
  width: 118px;
  height: 96px;

}

.reImg {
  width: 88px;
  height: 66px;
  border-radius: 8px;
  margin: 15px 15px;
}

.reRightBox {

  height: 96px;
}

.reSonTitle {
  margin-top: 15px;
  margin-right: 16px;
  height: 45px;
  text-align: left;
  font-weight: bolder;
  font-size: 14px;
  color: black;

}

.reDate {
  display: flex;
  align-items: center;
  height: 30px;
  font-size: 12px;
  color: #919bad;
}

.fade-enter-active {
  transition: all .3s ease;
}


.fade-enter {

  opacity: 0;

}

</style>
